import * as companyappApi from '@/api/companyappApi';
import { Debounce } from '@/utils/validate';
import { companyAppStatus } from '../../enum';
var props = {
  children: 'child',
  label: 'name',
  value: 'id',
  emitPath: false
};
export default function (_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'input',
    label: '促销名称：',
    prop: 'name',
    attrs: {
      placeholder: '请输入促销名称',
      clearable: true
    },
    events: {
      input: Debounce(function (value) {
        return handleSearch({
          name: value
        });
      })
    }
  }, {
    type: 'picker',
    label: '有效期：',
    prop: 'lifespanTime',
    attrs: {
      placeholder: '请选择',
      type: 'datetimerange',
      clearable: true,
      'start-placeholder': "开始日期",
      'end-placeholder': "结束日期",
      'value-format': 'yyyy-MM-dd HH:mm:ss'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          lifespanTime: value
        });
      }
    }
  }];
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}